export default __webpack_public_path__ + "static/media/TitilliumWeb-BoldItalic.7fc8c1d9.ttf";